document.addEventListener('turbolinks:load', () => {
	if($('body').attr('data-published') == 'false'){
		dispatchNotice(I18n.t('unpublished_page.title'), I18n.t('unpublished_page.message'), 'primary')
	}
})